export const PASSWORD_RESET_MAIL_SENT =
  'Reset password link sent to your email. Please check your inbox';
export const PASSWORD_RESET_SUCCESS = 'Password has been reset';
